// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/loading-placeholder/style/index.less
// module id = 105
// module chunks = 0